import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Question } from 'src/app/models/question.model';
import { QuestionnaireStore } from 'src/app/store/questionnaire-store';
import { filter, map } from 'rxjs';
import { AnswersStore } from 'src/app/store/answers-store';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import { Answer } from 'src/app/models/Answer.model';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatNativeDateModule } from '@angular/material/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { DualCalendarRangePickerComponent, ICalendarResults } from "../../../../../../shared/components/dual-calendar-range-picker/dual-calendar-range-picker.component";
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { QueDatePipe } from 'src/app/pipes/date.pipe';
import { DatePickerComponent } from "src/app/shared/components/date-picker/date-picker.component";
@Component({
    selector: 'que-date-question-display',
    templateUrl: './date-question-display.component.html',
    styleUrls: ['./date-question-display.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, ReactiveFormsModule, MatDatepickerModule, SvgIconComponent, TranslateDirective, TranslatePipe,
        MatInputModule, MatNativeDateModule,
        MatFormFieldModule, DualCalendarRangePickerComponent, OverlayModule, QueDatePipe, DatePickerComponent]
})
export class DateQuestionDisplayComponent implements OnInit {
  @Input() isPreview = false;
  @Input()
  question?: Question;
  @Input() modularId?: string;
  @Input() modularOrder?: number;
  @Input() viewAnswer = false;

  @ViewChild('trigger') trigger!: ElementRef;
  myAnswer?: Answer;
  answer = new FormControl();
  #answerStore = inject(AnswersStore);
  selectedDateIsOpened = false;
  #questionnaireStore = inject(QuestionnaireStore);
  eventDeleteModularuestionId$ = this.#answerStore.eventDeleteModularuestionId$;
  isNotUser$ = this.#questionnaireStore.isUser$.pipe(map(x => !x));
  isUserSig$ = this.#questionnaireStore.isUserSig$;
  readonly positonAreaForSelectedDate = [{
    originX: 'end',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];

  ngOnInit(): void {
    this.answer.setValidators(this.question?.requierd ? [Validators.required] : null);
    this.isNotUser$.subscribe((isNotUser) => {
      if (isNotUser) {
        this.answer.disable();
      } else {
        this.answer.enable();
      }
    });
    this.eventDeleteModularuestionId$.pipe(filter(id => id != undefined && id == this.question?.id)).subscribe(
      x => {
        this.getAnswers()
      }
    )
    this.getAnswers();
    this.answer.valueChanges.subscribe(
      ans => {
        if (!!this.question?.isFilterField) {
          const formattedAns = this.formatMonthYear(ans);
          this.#answerStore.updateMainAnswerAndSync(formattedAns);
        }
        this.#answerStore.updateAnswer({ id: 0, questionId: this.question?.id ?? 0, questionType: this.question?.type.id, modularQuestionGuid: this.modularId, modularRowNum: this.modularOrder, dateAnswerNTZ: ans, isValid: this.answer.valid })
      });
  }

  getAnswers() {
    this.#answerStore.answers$.pipe(
      map(arr => arr.find(ans => ans.questionId == this.question?.id && (!this.modularId || (ans.modularQuestionGuid == this.modularId && ans.modularRowNum == this.modularOrder))))).subscribe(x => {
        if (x) {
          this.myAnswer = x;
          if (x.dateAnswerNTZ)
            this.answer.setValue(x.dateAnswerNTZ, { emitEvent: false });
        }
      }).unsubscribe();
  }

  chooseDate(date: ICalendarResults) {
    if (date.startDate && this.isUserSig$()) {
      this.answer.setValue(date.startDate);
      // this.reminderForm.controls.endDate.setValue(date.startDate)
    }
    this.selectedDateIsOpened = false;

  }

  openPopupDate() {

    if (this.isUserSig$()) {
      const triggerRect = this.trigger.nativeElement.getBoundingClientRect();
      const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
      // Check if the menu would open out of the viewport
      if (triggerRect.bottom + 400 > viewportHeight) { // assuming 200px height for the menu
        this.positonAreaForSelectedDate[0].overlayY = 'bottom';
      } else {
        this.positonAreaForSelectedDate[0].overlayY = 'top';
      }
      this.selectedDateIsOpened = true;
    }
  }
  private formatMonthYear(value: any): string {
    const date = new Date(value);

    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();

    return `${month}/${year}`;
  }
}
